/**
 * @author gll
 * 功能：类目模块
 */
import { Service } from '@/tools'

export class CategoryService<T extends TCommodity.Category> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Category}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 类目搜索树形结构
  // /api/commodity/category/v1/getCategoryListTree
  getCategoryListTree = <K extends T['ApiGetCategoryListTree']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetCategoryListTree', data)

  // commodityCategoryInfo
  // 类目详情
  // /api/commodity/category/v1/info
  info = <K extends T['ApiInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiInfo', data)

  // commodityCategoryUpdate
  // 类目编辑
  // /api/commodity/category/v1/update
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data, '更新成功')

  // commodityCategoryAdd
  // 类目新增
  // /api/commodity/category/v1/add
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  // 类目删除
  // /api/commodity/category/v1/updateDeleteFlag
  updateDeleteFlag = <K extends T['ApiUpdateDeleteFlag']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateDeleteFlag', data)

  // commodityCategoryEnable
  // 类目启用
  // /api/commodity/category/v1/enable
  enable = <K extends T['ApiEnable']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEnable', data, '修改成功')

  // commodityCategoryDisable
  // 类目禁用
  // /api/commodity/category/v1/disable
  disable = <K extends T['ApiDisable']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDisable', data, '修改成功')

  // getCategoryList
  // 查询类目-逐级查询
  // /api/commodity/category/v1/categoryList
  categoryList = <K extends T['ApiCategoryList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCategoryList', data)

  // 类目详情-类目模板
  // /api/commodity/category/v1/categoryTemplate
  categoryTemplate = <K extends T['ApiCategoryTemplate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCategoryTemplate', data)

  //上移
  // /api/commodity/category/v1/moveUpCategory
  moveUpCategory = <K extends T['ApiMoveUpCategory']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiMoveUpCategory', data, '上移成功')

  //下移
  // /api/commodity/category/v1/moveDownCategory
  moveDownCategory = <K extends T['ApiMoveDownCategory']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiMoveDownCategory', data, '下移成功')

  // 返回树形结构(其他中心调用)
  // /api/commodity/category/v1/getCategoryTreeAll
  getCategoryTreeAll = <K extends T['ApiGetCategoryTreeAll']>(): Promise<K['res']> => this.post2('v1/ApiGetCategoryTreeAll', {})

  // 查看类目是否被商品引用
  // /api/commodity/category/v1/selectCategoryCommodityQuote
  selectCategoryCommodityQuote = <K extends T['ApiSelectCategoryCommodityQuote']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectCategoryCommodityQuote', data)

  // 获取默认类目
  // /api/commodity/category/v1/selectDefaultCategory
  selectDefaultCategory = <K extends T['ApiSelectDefaultCategory']>(): Promise<K['res']> => this.post2('v1/ApiSelectDefaultCategory')
}
